module.exports = __webpack_public_path__ + "static/media/ellipsis.74754538.svg";